export const apiBaseUri  = process.env.NODE_ENV === 'production' ? 'https://api.urbaneez.art/graphql' : 'http://localhost:4001/graphql';
// export const restBaseUri  = process.env.NODE_ENV === 'production' ? 'https://api.urbaneez.art' : 'http://localhost:4001';
export const restBaseUri  = process.env.NODE_ENV === 'production' ?  'https://api.urbaneez.art' : 'http://localhost:4001';
